// extracted by mini-css-extract-plugin
export var directoryCarImg = "carDirectory-module--directoryCarImg--1kEMM";
export var images = "carDirectory-module--images--1xo9v";
export var cardSelector = "carDirectory-module--cardSelector--2xZzR";
export var zoomIn = "carDirectory-module--zoomIn--12M-e";
export var infoCard = "carDirectory-module--infoCard--32RGj";